import { cn } from "@ui/lib/utils";

export const Skeleton = ({ className, variant = "default" }: { className?: string; variant?: "dark" | "default" }) => {
  return (
    <div className={cn("animate-opacity h-40 rounded-lg", variant === "dark" ? "bg-darker" : "bg-dark", className)} />
  );
};
